(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fotosconresenas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-rc-carousel]').forEach(function (c) {
        if (c.dataset.rcReady) return;
        c.dataset.rcReady = '1';
        var track = c.querySelector('[data-rc-track]');
        var prev = c.querySelector('[data-rc-prev]');
        var next = c.querySelector('[data-rc-next]');
        var dots = c.querySelector('[data-rc-dots]');
        var gap = 16;

        function pages() {
          return Math.max(1, Math.ceil((track.scrollWidth - 2) / (track.clientWidth + gap)));
        }
        function current() {
          var max = track.scrollWidth - track.clientWidth;
          if (max <= 0) return 0;
          if (track.scrollLeft >= max - 2) return pages() - 1;
          return Math.min(pages() - 1, Math.round(track.scrollLeft / (track.clientWidth + gap)));
        }
        function goTo(i) {
          track.scrollTo({ left: i * (track.clientWidth + gap), behavior: 'smooth' });
        }
        function render() {
          var n = pages();
          var multi = n > 1;
          prev.hidden = !multi;
          next.hidden = !multi;
          dots.hidden = !multi;
          if (dots.children.length !== n) {
            dots.innerHTML = '';
            for (var i = 0; i < n; i++) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'rc__dot';
              b.setAttribute('aria-label', 'Ir a la página ' + (i + 1));
              (function (idx) { b.addEventListener('click', function () { goTo(idx); }); })(i);
              dots.appendChild(b);
            }
          }
          var cur = current();
          Array.prototype.forEach.call(dots.children, function (d, i) {
            d.setAttribute('aria-current', i === cur ? 'true' : 'false');
          });
        }

        prev.addEventListener('click', function () {
          var cur = current();
          goTo(cur === 0 ? pages() - 1 : cur - 1);
        });
        next.addEventListener('click', function () {
          var cur = current();
          goTo(cur >= pages() - 1 ? 0 : cur + 1);
        });
        track.addEventListener('scroll', function () { window.requestAnimationFrame(render); }, { passive: true });
        window.addEventListener('resize', render);
        render();
      });
    }
    function boot() { init(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["paksss"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-mp]').forEach(function (el) {
        if (el.dataset.mpReady) return;
        el.dataset.mpReady = '1';

        var qty = el.querySelector('[data-mp-qty]');
        function syncQty() {
          var c = el.querySelector('input[name="sp-pack"]:checked');
          if (c && qty) qty.value = c.dataset.qty;
        }
        el.addEventListener('change', syncQty);
        syncQty();

        var slides = el.querySelectorAll('[data-mp-slide]');
        var thumbs = el.querySelectorAll('[data-mp-thumb]');
        thumbs.forEach(function (t) {
          t.addEventListener('click', function () {
            var i = t.getAttribute('data-mp-thumb');
            slides.forEach(function (s) { s.hidden = s.getAttribute('data-mp-slide') !== i; });
            thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
          });
        });
      });
    }
    function boot() { init(document); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-rr-carousel]').forEach(function (c) {
        if (c.dataset.rrReady) return;
        c.dataset.rrReady = '1';
        var track = c.querySelector('[data-rr-track]');
        var dotsBox = c.querySelector('[data-rr-dots]');
        var slides = track.children;
        if (!slides.length) return;
        function step() { return slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0); }
        function pageSize() { return Math.max(1, Math.round(track.clientWidth / step())); }
        function build() {
          dotsBox.innerHTML = '';
          var pages = Math.max(1, Math.ceil(slides.length / pageSize()));
          for (var i = 0; i < pages; i++) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'rr__dot';
            b.setAttribute('aria-label', 'Ir a la página ' + (i + 1));
            (function (n) { b.addEventListener('click', function () { track.scrollTo({ left: n * pageSize() * step() }); }); })(i);
            dotsBox.appendChild(b);
          }
          update();
        }
        function update() {
          var idx = Math.round(track.scrollLeft / (pageSize() * step()));
          Array.prototype.forEach.call(dotsBox.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
        }
        c.querySelector('[data-rr-prev]').addEventListener('click', function () { track.scrollBy({ left: -pageSize() * step() }); });
        c.querySelector('[data-rr-next]').addEventListener('click', function () { track.scrollBy({ left: pageSize() * step() }); });
        track.addEventListener('scroll', function () { window.requestAnimationFrame(update); });
        window.addEventListener('resize', build);
        build();
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
